import React, { PureComponent, memo } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Swal from "sweetalert2";

import { Colores_Lista, Color_Eliminar, Color_Agregar, Color_Modificar } from "../../request/MantenimientosRequest";
import { Notificacion } from "../../components/Util/Notificacion/Notificacion";
import ColoresItfz from "./Interfaz/coloresIntfz.jsx";

class colores extends PureComponent {
  _isMounted = false;

  state = {
    Datos: {
      titulo: "Lista de Colores"
    },
    listaColoresOrig: [],
    listaColores: [],
    selectedColor: 0,
    disabled: {
      Acciones: true,
      HabilitarAplicar: ""
    },
    buscar: "",
    nuevoRegistro: false,
    paginaActual: 1,
    cantidadRegistrosPaginaTabla: 10
  }

  componentDidMount() {
    this._isMounted = true;
    this.cargarRegistros();
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  cargarRegistros = async () => {
    const response = await Colores_Lista(this.props.token, this.props.empresa.Id);
    if (response.Exitoso) {
      let paginaActual = this.state.paginaActual;
      if (paginaActual > 1 && ((paginaActual - 1) * this.state.cantidadRegistrosPaginaTabla) >= response.Datos.length) {
        paginaActual--;
      }

      this._isMounted && this.setState({ listaColores: response.Datos, listaColoresOrig: response.Datos, nuevoRegistro: false, paginaActual });
    } else {
      Notificacion.error(response.Mensaje);
    }
  }

  guardarDatos = async (newValue, row) => {

    let response = null;

    if (this.state.nuevoRegistro && row.Color_Id === 0) {

      response = await Color_Agregar(this.props.token, this.props.empresa.Id, 0, newValue);
      if (response.Exitoso) {
        this.setState({ nuevoRegistro: false });
        this.cargarRegistros();
        Notificacion.success("Se registró la información con éxito");
      } else {
        Notificacion.error(response.Mensaje);
      }
    } else {

      response = await Color_Modificar(this.props.token, this.props.empresa.Id, row.Color_Id, newValue);
      if (response.Exitoso) {
        Notificacion.success("Se registró la información con éxito");
      } else {
        Notificacion.error(response.Mensaje);
      }
    }
  }

  borrarDatos = async () => {
    let id = this.state.selectedColor;

    if (this.validaSeleccionado()) {
      const resultado = await Color_Eliminar(this.props.token, this.props.empresa.Id, id);
      if (resultado.Exitoso) {
        this.setState({ selectedColor: 0 });
        this.cargarRegistros();
        Notificacion.success("Se eliminó con éxito.");
      } else {
        Notificacion.error("Error: " + resultado.Mensaje);
      }
    }
  }

  cambiarTamanioPagina = (cantidad) => {
    this.setState({ cantidadRegistrosPaginaTabla: cantidad });
  }

  cambiarPagina = (pagina) => {
    this.setState({ paginaActual: pagina });
  }

  validaSeleccionado = () => {
    const id = this.state.selectedColor;
    if (id) {
      return true;
    } else {
      Notificacion.error("Debe seleccionar un registro.");
      return false;
    }
  }

  ingresarDatos = (oldValue, newValue, row, column) => {
    this.guardarDatos(newValue, row);
    return true;
  };

  ingresarFila = () => {
    const { nuevoRegistro, paginaActual, cantidadRegistrosPaginaTabla } = this.state;

    if (!nuevoRegistro) {
      let listaColores = [...this.state.listaColores];
      const nuevoRegistro = { Emp_Id: 0, Color_Id: 0, Nombre: "" };
      const total = listaColores.length;
      const cantidadPaginas = total / cantidadRegistrosPaginaTabla;
      const poseeDecimales = cantidadPaginas.toString().indexOf('.') !== -1;
      let itemsUltimaPagina = cantidadRegistrosPaginaTabla;
      if (poseeDecimales) {
        itemsUltimaPagina = total - (Math.floor(cantidadPaginas) * cantidadRegistrosPaginaTabla);
      }

      let indice = 0;
      if (paginaActual === Math.ceil(cantidadPaginas)) {
        indice = total - itemsUltimaPagina;
      }
      else {
        indice = (paginaActual * cantidadRegistrosPaginaTabla) - cantidadRegistrosPaginaTabla;
      }

      listaColores.splice(indice, 0, nuevoRegistro);
      this._isMounted && this.setState({ nuevoRegistro: true, listaColores });
    }
  };

  handleBorrar = () => {
    let resultado = false;
    if (this.validaSeleccionado()) {
      Swal.fire({
        title: "Eliminar Color",
        html: "<h4>¿Está seguro que desea eliminar el registro?</h4>",
        showCancelButton: true,
        confirmButtonText: '<h5><i class="fa fa-check fa-fw"></i> Sí</h5>',
        cancelButtonText: '<h5><i class="fa fa-remove fa-fw"></i> No</h5>',
        reverseButtons: true,
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          resultado = true;
          this.borrarDatos();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          resultado = false;
        }
      });
    }

    return resultado;
  };

  onRowSelect = (row, isSelected) => {
    let disabled = { ...this.state.disabled };
    disabled.Acciones = !isSelected;

    let selectedColor = 0;
    if (isSelected && row) {
      selectedColor = row.Color_Id;
    }

    this._isMounted && this.setState({ disabled, selectedColor });
  };

  filtrarRegistro = (event) => {
    if (event.key !== "Enter") return;

    const { value } = event.target;
    this._isMounted && this.setState({ buscar: value, });
    const { listaColoresOrig } = this.state;

    let result = [];
    if (value.trim().length > 0) {

      result = listaColoresOrig.filter(item => item.Nombre.toUpperCase().indexOf(value.toUpperCase().trim()) != -1);
      if (result.length > 0) {
        this._isMounted && this.setState({ listaColores: result });

      } else {

        result = listaColoresOrig.filter(item => item.Color_Id === value.trim());
        if (result.length > 0) {
          this._isMounted && this.setState({ listaColores: result });
        }
      }
    } else {
      this._isMounted && this.setState({ listaColores: listaColoresOrig });
    }
  };

  onFocusInput = (event) => {
    event.target.value = this.state.buscar;
  };

  render() {
    const { Datos, listaColores, paginaActual } = this.state;

    return (
      <ColoresItfz
        listaColores={listaColores}
        Datos={Datos}
        onRowSelect={this.onRowSelect}
        ingresarDatos={this.ingresarDatos}
        handleBorrar={this.handleBorrar}
        filtrarRegistro={this.filtrarRegistro}
        onFocusInput={this.onFocusInput}
        ingresarFila={this.ingresarFila}
        paginaActual={paginaActual}
        onPageChange={this.cambiarPagina}
        onSizePerPageChange={this.cambiarTamanioPagina}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.usuario.token,
    empresa: state.parametros.empresa
  };
};

export default connect(mapStateToProps)(withRouter(memo(colores)));
